import { Button, Modal } from 'antd';
import { useStore } from 'zustand';

import { inventoryStore } from '../../InventoryStore';

import './SaveInventoryModal.scss';

export const SaveInventoryModal = () => {
  const form = useStore(inventoryStore, (state) => state.form);

  const saveChangesModal = useStore(
    inventoryStore,
    (state) => state.saveChangesModal
  );
  const setSaveChangesModal = useStore(
    inventoryStore,
    (state) => state.setSaveChangesModal
  );
  const setTimePeriod = useStore(
    inventoryStore,
    (state) => state.setTimePeriod
  );
  const setFormHasChanged = useStore(
    inventoryStore,
    (state) => state.setFormHasChanged
  );

  const changeTimePeriod = () => {
    setFormHasChanged(false);

    setTimePeriod({
      startDate: saveChangesModal.timePeriod.startDate,
      endDate: saveChangesModal.timePeriod.endDate,
    });
  };

  const handleSave = () => {
    setSaveChangesModal({
      isVisible: false,
      timePeriod: { startDate: new Date(), endDate: new Date() },
    });
    form?.submit();
  };

  const handleCancel = () => {
    setSaveChangesModal({
      isVisible: false,
      timePeriod: { startDate: new Date(), endDate: new Date() },
    });
  };

  const handleDiscard = () => {
    setSaveChangesModal({
      isVisible: false,
      timePeriod: { startDate: new Date(), endDate: new Date() },
    });

    changeTimePeriod();
  };

  const renderFooter = () => {
    return (
      <div className="footer">
        <div className="left">
          <Button onClick={handleCancel}>Cancel</Button>
        </div>
        <div className="right">
          <Button onClick={handleDiscard}>Discard changes</Button>
          <Button type="primary" onClick={handleSave}>
            Save
          </Button>
        </div>
      </div>
    );
  };

  return (
    <Modal
      width={466}
      open={saveChangesModal.isVisible}
      title={'Save changes'}
      onOk={handleSave}
      maskClosable={false}
      onCancel={handleCancel}
      closable={true}
      className="save-inventory-modal"
      destroyOnClose={true}
      footer={renderFooter()}
      centered
    >
      <div>To move on to the next date range, please save your changes.</div>
    </Modal>
  );
};
